import { RiMapPinLine } from "@remixicon/react";
import { DivIcon } from "leaflet";
import "leaflet/dist/leaflet.css";
import { renderToStaticMarkup } from "react-dom/server";
export const defaultMakersConfig = {
  iconWidth: 36,
  iconHeight: 36,
};

export function MarkerIcon() {
  return new DivIcon({
    html: renderToStaticMarkup(
      <div
        className="flex items-center justify-center bg-primary rounded-full"
        style={{
          width: defaultMakersConfig.iconWidth,
          height: defaultMakersConfig.iconHeight,
        }}
      >
        <RiMapPinLine size={20} className="text-white" />
      </div>
    ),
    className: "disable-default-marker-styling",
    iconSize: [defaultMakersConfig.iconWidth, defaultMakersConfig.iconHeight],
  });
}
